import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { ScVipTransferSuccess } from './styled';

export const VipTransferSuccess = () => {
  const { t } = useTranslation('vip');

  return (
    <ScVipTransferSuccess>
      <ImageComponent
        alt="success-icon"
        height={80}
        src="/vip/email-success.webp"
        width={80}
      />
      <div className="content-wrapper">
        <span className="title">
          {t('steps.vipTransfer.transferForm.successTitle')}
        </span>
        <span className="description">
          {t('steps.vipTransfer.transferForm.successDescription')}
        </span>
      </div>
    </ScVipTransferSuccess>
  );
};
